import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDashboardAnalytics,
  siteSpecificAnalytics,
} from "../../services/Analytics";

// dashboard analytics thunk
export const dashboardAnalytics = createAsyncThunk(
  "analytics/dashboard",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDashboardAnalytics();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// site-specific analytics thunk
export const fetchSiteAnalytics = createAsyncThunk(
  "analytics/site",
  async ({ siteId, period = "7d" }, { rejectWithValue }) => {
    try {
      const response = await siteSpecificAnalytics({ siteId, period });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: {
    analytics: null,
    siteAnalytics: null,
    loading: false,
    siteAnalyticsLoading: false,
    error: null,
    siteAnalyticsError: null,
  },
  reducers: {
    clearSiteAnalytics: (state) => {
      state.siteAnalytics = null;
      state.siteAnalyticsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dashboardAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dashboardAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.analytics = action.payload || action.payload;
      })
      .addCase(dashboardAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchSiteAnalytics.pending, (state) => {
        state.siteAnalyticsLoading = true;
        state.siteAnalyticsError = null;
      })
      .addCase(fetchSiteAnalytics.fulfilled, (state, action) => {
        state.siteAnalyticsLoading = false;
        state.siteAnalytics = action.payload;
      })
      .addCase(fetchSiteAnalytics.rejected, (state, action) => {
        state.siteAnalyticsLoading = false;
        state.siteAnalyticsError = action.payload || action.error.message;
      });
  },
});

export const { clearSiteAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;
